import type {
  ClientCompanyViewDto,
  ClientCompanyUpdateDto,
  ClientCompanyCreateDto,
  ApiResponse
} from '@/types/company'
import { apiClient } from './client'

// Client Company API functions
export const clientCompanyApi = {
  // Get company by ID
  getById: (id: string): Promise<ApiResponse<ClientCompanyViewDto>> =>
    apiClient.get(`/api/clientcompanies/${id}`),

  // Update company
  update: (clientCompanyId: string, company: ClientCompanyUpdateDto): Promise<ApiResponse<ClientCompanyViewDto>> =>
    apiClient.put(`/api/ClientCompanies/${clientCompanyId}`, company),

  // Get customers managed by a company (full view DTOs with workspaces)
  getCustomersManagedByCompany: (companyId: string): Promise<ApiResponse<ClientCompanyViewDto[]>> =>
    apiClient.get(`/api/ClientCompanies/${companyId}/Customers`),

  // Create a new client company (returns ClientCompanyViewDto)
  create: (managingClientCompanyId: string, payload: ClientCompanyCreateDto): Promise<ApiResponse<ClientCompanyViewDto>> =>
    apiClient.post(`/api/ClientCompanies/${managingClientCompanyId}/Customers`, payload),

  // Scrape company website (Firecrawl pipeline: scrape, vectorize, update company)
  scrapeWebsite: (clientCompanyId: string, url?: string): Promise<ApiResponse<void>> => {
    const query = url ? `?url=${encodeURIComponent(url)}` : ''
    return apiClient.post(`/api/ClientCompanies/${encodeURIComponent(clientCompanyId)}/scrape${query}`, {})
  },

  // Check whether a proposed ClientCompany slug is globally available.
  checkSlug: (slug: string): Promise<ApiResponse<{ slug: string; available: boolean }>> =>
    apiClient.get(`/api/ClientCompanies/CheckSlug?slug=${encodeURIComponent(slug)}`),
}
